import {
  TrendingUp,
  Archive,
  Calendar,
  LayoutGrid,
  List,
  Eye,
  EyeOff,
  History as HistoryIcon,
  Route,
} from 'lucide-react'
import type { MainTab, ViewMode } from '@/types'
import {
  PageToolbar,
  SegmentTabs,
  ToolbarControlsGroup,
  ToolbarIconButton,
  ToolbarToggleGroup,
  type SegmentTab,
} from '@/components/ui/page-toolbar'

const mainTabs: SegmentTab<MainTab>[] = [
  { id: 'active', label: 'Pipeline Ativo', shortLabel: 'Pipeline', icon: TrendingUp },
  { id: 'future', label: 'Fechamento Futuro', shortLabel: 'Futuro', icon: HistoryIcon },
  { id: 'closed', label: 'Histórico / Encerrados', shortLabel: 'Histórico', icon: Archive },
  { id: 'calendar', label: 'Calendário', shortLabel: 'Calendário', icon: Calendar },
]

interface DealsTopbarProps {
  mainTab: MainTab
  setMainTab: (tab: MainTab) => void
  viewMode: ViewMode
  setViewMode: (mode: ViewMode) => void
  isPulseVisible: boolean
  setIsPulseVisible: (v: boolean) => void
  areValuesVisible: boolean
  setAreValuesVisible: (v: boolean) => void
  filters?: React.ReactNode
}

export function DealsTopbar({
  mainTab,
  setMainTab,
  viewMode,
  setViewMode,
  isPulseVisible,
  setIsPulseVisible,
  areValuesVisible,
  setAreValuesVisible,
  filters,
}: DealsTopbarProps) {
  return (
    <PageToolbar
      navigation={
        <SegmentTabs
          tabs={mainTabs}
          value={mainTab}
          onChange={setMainTab}
          ariaLabel='Visões do pipeline'
        />
      }
      controls={
        <ToolbarControlsGroup>
          <ToolbarIconButton
            active={isPulseVisible}
            onClick={() => setIsPulseVisible(!isPulseVisible)}
            title={isPulseVisible ? 'Ocultar metas' : 'Mostrar metas'}
            aria-label={isPulseVisible ? 'Ocultar metas' : 'Mostrar metas'}
          >
            {isPulseVisible ? <Eye size={16} /> : <EyeOff size={16} />}
          </ToolbarIconButton>

          {mainTab !== 'calendar' && (
            <ToolbarIconButton
              active={areValuesVisible}
              onClick={() => setAreValuesVisible(!areValuesVisible)}
              title={areValuesVisible ? 'Ocultar valores' : 'Mostrar valores'}
              aria-label={areValuesVisible ? 'Ocultar valores' : 'Mostrar valores'}
            >
              {areValuesVisible ? <Eye size={16} /> : <EyeOff size={16} />}
            </ToolbarIconButton>
          )}

          {mainTab !== 'calendar' && (
            <ToolbarToggleGroup
              value={viewMode}
              onChange={setViewMode}
              options={[
                { id: 'journey', icon: Route, label: 'Visão Jornada' },
                { id: 'kanban', icon: LayoutGrid, label: 'Visão Kanban' },
                { id: 'list', icon: List, label: 'Visão Lista' },
              ]}
            />
          )}
        </ToolbarControlsGroup>
      }
      filters={filters}
    />
  )
}
